import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adsListingService } from '../ads-listing.service';
import type {
	TUseDeleteAdConfig,
	TDeleteAdParams,
	TUseDeleteAdReturn
} from './use-delete-ad.types';

const useDeleteAd = (config: TUseDeleteAdConfig): TUseDeleteAdReturn => {
	const { vehicleType, onSuccess, onError } = config;
	const queryClient = useQueryClient();

	const { mutate, mutateAsync, isPending, isError, error } = useMutation({
		mutationFn: ({ id }: TDeleteAdParams) =>
			adsListingService.deleteIncompleteAd(vehicleType, id),
		onSuccess: (data) => {
			void queryClient.invalidateQueries({
				queryKey: ['ads', 'list', vehicleType],
				exact: false
			});
			void queryClient.invalidateQueries({
				queryKey: ['ads', 'tab-count', vehicleType],
				exact: false
			});
			onSuccess?.(data);
		},
		onError: (err: Error) => {
			onError?.(err);
		}
	});

	return {
		deleteAd: mutate,
		deleteAdAsync: mutateAsync,
		isDeleting: isPending,
		isError,
		error: error as Error | null
	};
};

export { useDeleteAd };
